import React from "react";
import { FiCoffee } from "react-icons/fi";

export default function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl sm:rounded-2xl border-2 border-dashed border-gray-300 bg-white py-12 sm:py-16 px-4 dark:border-gray-700 dark:bg-boxdark">
      <div className="rounded-full bg-gradient-to-br from-purple-100 to-purple-100 p-5 sm:p-6 dark:from-purple-900/30 dark:to-purple-900/30">
        <FiCoffee
          size={40}
          className="sm:w-12 sm:h-12 text-gray-400 dark:text-gray-600"
        />
      </div>
      <p className="mt-4 sm:mt-5 text-base sm:text-lg font-semibold text-gray-700 dark:text-gray-300 text-center">
        Nenhuma refeição registrada
      </p>
      <p className="mt-2 text-xs sm:text-sm text-gray-500 dark:text-gray-500 text-center max-w-sm">
        As refeições registradas aparecerão aqui quando o aluno começar a
        registrar sua alimentação
      </p>
    </div>
  );
}
